import { graphql, Link } from 'gatsby'
import get from 'lodash.get'
import React from 'react'
import { CardActu } from '../components/card-actu'
import colors from '../theme/colors'
import styled from 'styled-components'
import Button from '../components/button'
import Layout from '../components/layout'
import Responsive from '../components/responsive'
import Seo from '../components/seo'

const Post = ({ data, uri }) => {
    const post = get(data, 'prismicPost')
    const { title, content } = get(post, 'data')

    return (
        <>
            <Seo title={title.text} description={content.text.slice(0, 160)} />
            <Layout uri={uri} withMiniHeader>
                <StyledNavigation>
                    <Responsive>
                        <Link to={'/'}>
                            <Button direction='rtl' icon='ArrowLeft'>
                                Retour
                            </Button>
                        </Link>
                    </Responsive>
                </StyledNavigation>

                <StyledSection>
                    <Responsive>
                        <StyledCardContainer>
                            <CardActu post={post} />
                        </StyledCardContainer>
                    </Responsive>
                </StyledSection>
            </Layout>
        </>
    )
}

const StyledNavigation = styled.nav`
  background: ${colors.beige50};
  backdrop-filter: blur(10px);
  padding: 1rem 0;

  ${Responsive} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`

const StyledSection = styled.section`
  padding: 0 0 4rem;
`

const StyledCardContainer = styled.div`
  padding: 2rem 0;
`

export const query = graphql`
    query($uid: String!) {
        prismicPost(uid: { eq: $uid }) {
            uid
            data {
                title {
                  text
                }
                cover {
                  alt
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                content {
                  html,
                  text
                }
            }
        }
    }
`

export default Post